var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Collection, Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Represents the filter configuration for a column in the TreeGrid.
 */
export class Predicate extends ChildProperty {
}
__decorate([
    Property()
], Predicate.prototype, "field", void 0);
__decorate([
    Property()
], Predicate.prototype, "operator", void 0);
__decorate([
    Property()
], Predicate.prototype, "value", void 0);
__decorate([
    Property()
], Predicate.prototype, "matchCase", void 0);
__decorate([
    Property()
], Predicate.prototype, "ignoreAccent", void 0);
__decorate([
    Property()
], Predicate.prototype, "predicate", void 0);
__decorate([
    Property({})
], Predicate.prototype, "actualFilterValue", void 0);
__decorate([
    Property({})
], Predicate.prototype, "actualOperator", void 0);
__decorate([
    Property()
], Predicate.prototype, "type", void 0);
__decorate([
    Property()
], Predicate.prototype, "ejpredicate", void 0);
__decorate([
    Property()
], Predicate.prototype, "uid", void 0);
__decorate([
    Property()
], Predicate.prototype, "isForeignKey", void 0);
/**
 * Configures the filtering behavior of the TreeGrid, enabling complex data filtering capabilities.
 */
export class FilterSettings extends ChildProperty {
}
__decorate([
    Collection([], Predicate)
], FilterSettings.prototype, "columns", void 0);
__decorate([
    Property('FilterBar')
], FilterSettings.prototype, "type", void 0);
__decorate([
    Property()
], FilterSettings.prototype, "mode", void 0);
__decorate([
    Property(true)
], FilterSettings.prototype, "showFilterBarStatus", void 0);
__decorate([
    Property(1500)
], FilterSettings.prototype, "immediateModeDelay", void 0);
__decorate([
    Property()
], FilterSettings.prototype, "operators", void 0);
__decorate([
    Property(false)
], FilterSettings.prototype, "ignoreAccent", void 0);
__decorate([
    Property('Parent')
], FilterSettings.prototype, "hierarchyMode", void 0);
